/* eslint-disable prettier/prettier */
import styled, { css } from 'styled-components';

export const AgeText = styled.span<{ isOverlay: boolean }>`
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};

  ${({ isOverlay }) =>
    !isOverlay &&
    css`
      margin-top: 4px;
    `};

  @media (min-width: 768px) {
    margin-top: 4px;
  }
`;

export const PriceBottomContainer = styled.div<{ isOverlay: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
  text-align: right;
  ${({ theme }) => theme.kallisto.mixins.font('BodySmall')};
`;